(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .factory('SellerActivityFactory', SellerActivityFactory);

    SellerActivityFactory.$inject = ['$resource'];

    function SellerActivityFactory ($resource) {
        var resourceUrl =  'admin/api/activity';

        return $resource(resourceUrl, {}, {
            'findByCampaignId': {
                url: resourceUrl + '/seller-campaign/:campaignId/activities',
                method: 'GET',
                params: {
                    campaignId: '@campaignId',
                    customerName: '@customerName'
                },
                transformResponse: function (data, headers) {
                    const response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            },
            'countStatuses': {
                url: resourceUrl + '/seller-campaign/:campaignId/activities/count-status',
                method: 'GET',
                params: {
                    campaignId: '@campaignId'
                },
                transformResponse: function (data, headers) {
                    const response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            },
            'updateStatus': {
                url: resourceUrl + '/:id/update',
                method: 'POST',
                transformResponse: function (data, headers) {
                    const response = {};
                    response.data = angular.fromJson(data);
                    response.headers = headers();
                    return response;
                }
            }
        });
    }
})();
